var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('hm-header',{directives:[{name:"show",rawName:"v-show",value:(_vm.path != '/edit-page'),expression:"path != '/edit-page'"}],attrs:{"header-obj":_vm.headerObj}}),_c('router-view'),_c('hm-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.path != '/edit-page'),expression:"path != '/edit-page'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }